import { numberToPrettyString } from '@cian/utils';
import { CURRENCY_TYPE_SYMBOLS } from '../../../constants/symbols';
import { INewbuilding } from '../../../types/newbuilding';

export const getPriceFrom = (newbuilding: INewbuilding): string | undefined => {
  const { minPriceRur } = newbuilding;

  if (!minPriceRur) {
    return undefined;
  }

  const formattedMinPrice = numberToPrettyString(+minPriceRur).replace(/\s/g, '\xA0');

  return `от\xA0${formattedMinPrice}\xA0${CURRENCY_TYPE_SYMBOLS.Rur}`;
};
